import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface AuthState {
  loggedIn: boolean;
  sessionExpired: boolean;
  token: string;
}

const initialState: AuthState = {
  loggedIn: false,
  sessionExpired: false,
  token: '',
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginStatus: (state, action: PayloadAction<boolean>) => {
      state.loggedIn = action.payload;

      if (action.payload) {
        state.sessionExpired = false;
      }
    },
    endSession: (state, action: PayloadAction<boolean>) => {
      state.loggedIn = false;
      state.sessionExpired = action.payload;
      state.token = '';
    },
    updateTicket: (state, action: PayloadAction<string>) => {
      state.token = action.payload;
    },
  },
});

export const { endSession, loginStatus, updateTicket } = authSlice.actions;
export default authSlice.reducer;

// export const authReducer = (state = initialState, action: AuthActions | UserActions): AuthState => {
//   switch (action.type) {
//     case INITIALIZE_USER:
//       return {
//         ...state,
//         loggedIn: true,
//       };

//     case LOGOUT:
//       return initialState;

//     case USER_AUTH_TICKET:
//       return {
//         ...state,
//         token: action.token,
//       };

//     default:
//       return state;
//   }
// };
